import React from 'react';
import { Truck, Plane, Infinity, Shield, Clock, BadgeCheck } from 'lucide-react';

const Advantages = ({ t, language }) => {
  const isRo = language === 'ro';
  
  const advantages = [
    { 
      icon: Truck, 
      titleRo: 'Livrare gratuită în Brașov',
      titleEn: 'Free delivery in Brașov',
      descRo: 'Îți livrăm autoturismul gratuit la hotel, domiciliu sau Aeroportul Internațional Brașov-Ghimbav, pentru ca tu să economisești timp și să pleci la drum imediat.',
      descEn: 'We deliver your car for free to your hotel, home or Brașov-Ghimbav International Airport, so you save time and hit the road immediately.',
    },
    { 
      icon: Plane, 
      titleRo: 'Ridicare direct din aeroport',
      titleEn: 'Direct airport pickup',
      descRo: 'Aterizezi în Brașov? Autoturismul te așteaptă pregătit chiar la sosire, astfel încât să pornești imediat spre destinație, fără întârzieri sau transferuri suplimentare.',
      descEn: 'Landing in Brașov? Your car is ready right at arrival, so you can head to your destination immediately, with no delays or extra transfers.',
    },
    { 
      icon: Infinity, 
      titleRo: 'Kilometraj nelimitat',
      titleEn: 'Unlimited mileage',
      descRo: 'Condu oriunde în România fără restricții. Toate închirierile includ kilometraj nelimitat, pentru libertate totală în fiecare călătorie.',
      descEn: 'Drive anywhere in Romania without restrictions. All rentals include unlimited mileage, for total freedom on every journey.',
    },
    { 
      icon: Shield, 
      titleRo: 'Fără costuri ascunse',
      titleEn: 'No hidden costs',
      descRo: 'La Montréon știi întotdeauna ce plătești. Oferim prețuri transparente, fără taxe ascunse și fără surprize la preluarea sau returnarea autoturismului.',
      descEn: 'At Montréon you always know what you pay. We offer transparent pricing, with no hidden fees and no surprises at pickup or return.',
    },
    { 
      icon: Clock, 
      titleRo: 'Asistență 24/7',
      titleEn: '24/7 Assistance',
      descRo: 'Oriunde te afli, echipa noastră este disponibilă non-stop pentru suport și asistență. Călătorești cu încredere, știind că suntem mereu la un telefon distanță.',
      descEn: 'Wherever you are, our team is available around the clock for support and assistance. Travel with confidence, knowing we are always just a phone call away.',
    },
    { 
      icon: BadgeCheck, 
      titleRo: 'Garanție 0',
      titleEn: 'Zero deposit',
      descRo: 'Pentru un plus de confort și siguranță, poți opta pentru asigurarea SCDW, care îți oferă posibilitatea unei garanții 0, reducând grija și riscul pe durata închirierii.',
      descEn: 'For extra comfort and safety, you can opt for SCDW insurance, which offers you the option of a zero deposit, reducing worry and risk during your rental.',
    },
  ];

  return (
    <section className="py-20 sm:py-28 bg-[#ECFDF5]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-14 sm:mb-20">
          <p className="text-[#10B981] text-sm font-semibold tracking-[0.15em] uppercase mb-3">
            {isRo ? 'Avantajele Montréon' : 'Montréon Advantages'}
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0D1B3E] leading-tight mb-4">
            {isRo ? 'De ce să închiriezi cu Montréon?' : 'Why rent with Montréon?'}
          </h2>
          <p className="text-gray-500 text-base sm:text-lg max-w-3xl mx-auto leading-relaxed">
            {isRo 
              ? 'Bucură-te de o experiență simplă, sigură și fără griji. Oferim închirieri auto în Brașov cu livrare flexibilă, kilometraj nelimitat și servicii premium, astfel încât fiecare călătorie să înceapă în cele mai bune condiții.'
              : 'Enjoy a simple, safe and worry-free experience. We offer car rentals in Brașov with flexible delivery, unlimited mileage and premium services, so every journey starts in the best conditions.'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {advantages.map((adv, index) => {
            const Icon = adv.icon;
            return (
              <div 
                key={index}
                data-testid={`advantage-${index + 1}`}
                className="text-center group"
              >
                <div className="w-16 h-16 mx-auto mb-5 bg-[#10B981]/10 rounded-full flex items-center justify-center group-hover:bg-[#10B981]/20 transition-colors">
                  <Icon className="text-[#10B981]" size={28} />
                </div>
                <h3 className="font-display text-xl font-bold text-[#0D1B3E] mb-3">
                  {isRo ? adv.titleRo : adv.titleEn}
                </h3>
                <p className="font-body text-gray-500 text-sm leading-relaxed max-w-xs mx-auto">
                  {isRo ? adv.descRo : adv.descEn}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
